import React from 'react';
import InputMask from 'react-input-mask';
//import Select from 'react-select';
//import { Link } from 'react-router-dom';
import { Switch } from 'antd';

import HeaderBar from '../header-bar/header-bar';
import NavigationMenu from '../sidebar/navigation-menu';
import Footer from "../containers/footer";
import Loading from '../containers/loading';
import FlashMessage from '../containers/FlashMessage';
import MyPopover from '../containers/mypopover';
import Alert from '../containers/alert';
import Confirm from '../containers/confirm';

import style from './changePlan.style.js';

import OfficeService from '../../services/OfficeService';
import AuthService from '../../services/AuthService';
//import AddressService from '../../services/AddressService';
import TribunalService from '../../services/TribunalService';
import LawsuitService from '../../services/LawsuitService';
import PlansService from '../../services/PlansService';
import PublicationsService from '../../services/PublicationsService';
import { momentLocalizer } from 'react-big-calendar';

import moment from "moment";
//import ptBR from 'antd/lib/locale-provider/pt_BR';
import 'moment/locale/pt-br';

moment.locale('pt-BR');

//import { Progress } from 'antd';

export default class ConfigOffice extends React.Component { 
  _isMounted = false;

  componentWillUnmount() {
    this._isMounted = false;
  }

  constructor( props ) {
    super(props);

    this.authService = new AuthService();
    this.PublicationsService = new PublicationsService();

    this.handleChange = this.handleChange.bind(this);
    this.setBandeira = this.setBandeira.bind(this);
    this.selectChange = this.selectChange.bind(this);
    this.clickCobranca = this.clickCobranca.bind(this);
    this.update = this.update.bind(this);
    this.validateForm = this.validateForm.bind(this);

    this.state = {
      plan: 0,
      qtd_ativos: 0,
      qtd_arquivados: 0,
      ged: 0,
      ged_free: 0,
      ged_utilized: 0,
      ged_percent: 0,
      n_publicacoes: 0,
      maxLawsuits: 0,
      maxStorage: 0,
      maxPublication: 0,
      sliderLawsuit: 0,
      sliderStorage: 0,
      sliderPublication: 0,
      planLawsuits: [],
      planStorages: [],
      planPublications: [],
      qtd_processos: 0,
      qtd_storage: 0,
      qtd_storage_nice: 0,
      qtd_publicacoes: 0,
      valorLawsuit: "0",
      valorStorage: "0",
      valorPublicacoes: "0",
      cobranca: "mensal",
      total: 0,
      totalPlan: 0,
      alterarPagamento: false,
      card_cvv: "",
      holder_name: "",
      card_number: "",
      card_expiration: "",
      cadastro_ModoPagamento: "credito",
      loadingVisible: false,
      loadingMessage: [],
      message: "",
      showAlert: false,
      showConfirm: false,
      publications: [],
      free: "",
      errors: {},
      expiration: ""
    }

    window.scrollTo(0,0);

    if( !this.authService.can('acesso_configuracoes', true) ){
      this.props.history.replace('/');
    }

    var url_string = window.location.href;
    var url = new URL(url_string);
    var vencido = url.searchParams.get("plano_vencido");
    //console.log(url.search); //console.log(movements);
    if( vencido !== null ){
      this.state.showAlert = true;
      this.state.message = "Seu plano venceu, renove agora!";
      //alert("Seu plano venceu, renove agora!");
    }

  }

  setStyle() {
    return { __html: style[0].key };
  }

  componentDidMount( ) { 
        this._isMounted = true;

        document.addEventListener("cancelDialogConfirm", (e) => {
          if( this._isMounted ){
            this.setState({
              showConfirm: false
            });
          }
        });
    
        document.addEventListener("confirmDialogConfirm", (e) => {
          if( this._isMounted ){
            this.setState({
              showConfirm: false
            });
    
            this.update(e, true);
          }
        });

        document.addEventListener("cancelAlert", (e) => {
            this.setState({
              showAlert: false
            });
        });

        document.addEventListener("cancelLoading", (e) => {
            this.setState({
              loadingVisible: false
            });
        });

        this.atualizaDados();

        this.listPublications();

  }

  listPublications () {
    this.PublicationsService.list().then( publications => {
        this.setState({
            publications
        });
    });
  }

  atualizaDados = () => {
        this.OfficeService = new OfficeService();
        this.PlansService = new PlansService();

        //let token = JSON.parse(localStorage.getItem('loggedUser')).office_token;
        let qtd_arquivados=0; let qtd_ativos=0; let plan = 0; let ged = 0; let n_publicacoes = 0; let ged_gb = 0;


        this.OfficeService.getPlan().then(response =>{

              if( this._isMounted ) {

                    //console.log(response);
                    if( response.success === false ){

                    }else{

                          ged = response.armazenamento_disponivel/1000000000;
                          let ged_utilized = response.armazenamento_usado/1000000000;

                          plan = response.plan_lawsuit.quantidade_processos;
                          ged_gb = response.plan_storage.gb;
                          n_publicacoes = response.plan_publication_number;

                          //processos quantidade
                          this.tribunalService = new TribunalService();
                          this.lawsuitService = new LawsuitService();

                          /*this.tribunalService.list().then(res =>{

                                if( this._isMounted ) {

                                      res.map( ( tribunal ) => {

                                            this.lawsuitService.list( tribunal.id ).then(res =>{

                                                if( this._isMounted ) {

                                                      res.map( (lawsuit)=>{
                                                          if ( lawsuit.arquivo === 1 ) {
                                                            qtd_arquivados++;
                                                          }else{
                                                            qtd_ativos++;
                                                          }
                                                          return lawsuit;
                                                      });*/

                                                     //console.log(ged_utilized);
                                                     //console.log(ged);

                                                      this.setState({
                                                        qtd_arquivados,
                                                        qtd_ativos: response.ativos,
                                                        plan,
                                                        free: ( response.teste_gratis === 0 ) ? "" : ": Plano FREE",
                                                        expiration: response.data_expiracao,
                                                        totalPlan: ( response.total !== null ) ? response.total.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) : 0,
                                                        ged,
                                                        ged_free: response.plan_lawsuit.armazenamento_gratuito,
                                                        ged_utilized,
                                                        ged_percent: parseFloat( (ged_utilized*100/ged).toFixed(4) ),
                                                        n_publicacoes,
                                                        ged_gb
                                                      });

                            /*                    }
                                            });
                                            return tribunal;

                                      });
                                      //console.log(res);
                                }

                          });*/

                    }


                    this.PlansService.getPlanLawsuits().then( planLawsuits =>{

                        if( this._isMounted ) {

                              this.PlansService.getPlanStorages().then( planStorages =>{

                                    if( this._isMounted ) {
                            
                                        this.PlansService.getPlanPublications().then( planPublications =>{

                                            if( this._isMounted ) {
                                
                                                    //console.log(planPublications);
                                        
                                                    let maxLawsuits = Math.max.apply(null, planLawsuits.map(m=>m.id) )-1;
                                                    let maxStorage = Math.max.apply(null, planStorages.map(m=>m.id) )-1;
                                                    let maxPublication = 20;
                                                    let sliderLawsuit = planLawsuits.filter( ( item ) =>{ return item.quantidade_processos === plan } )[0];
                                                    //console.log(sliderLawsuit);
                                                    sliderLawsuit = ( typeof sliderLawsuit !== "undefined" ) ? sliderLawsuit.id-1 : 0;

                                                    let sliderStorage = planStorages.filter( ( item ) =>{ return item.gb === ged_gb } )[0];
                                                    sliderStorage = sliderStorage.id-1;

                                                    let sliderPublication = n_publicacoes;
                                        
                                                    this.setState({
                                                      maxLawsuits,
                                                      maxStorage,
                                                      maxPublication,
                                                      sliderLawsuit,
                                                      sliderStorage,
                                                      sliderPublication,
                                                      planLawsuits,
                                                      planStorages,
                                                      planPublications
                                                    });

                                                    this.atualizaProcesso();
                                                    this.atualizaStorage();
                                                    this.atualizaPublicacoes();

                                            }
                                
                                        });

                                    }
                        
                              });

                        }
                
                    });

              }

        });
  }

  atualizaProcesso = () => {

    let armazenamento_gratuito = 0; 
    let valor_por_processo = 0;
    let qtd_processos = this.state.planLawsuits.map(x=>x.quantidade_processos)[this.state.sliderLawsuit];
    let planLawsuits = this.state.planLawsuits;
    let descontoAnual = 15;
    let valorLawsuit = 0;

    //console.log(this.state.sliderLawsuit);
    //console.log(qtd_processos);
    
    let obj = this.state.planLawsuits.find(x => qtd_processos > 0 && qtd_processos <= x.quantidade_processos);
    
    if(!obj && qtd_processos!=='0'){
      obj = planLawsuits.pop(); 
    }
    if(obj){
      armazenamento_gratuito = obj.armazenamento_gratuito;
      valor_por_processo = obj.valor_por_processo;
    }

    //console.log( valor_por_processo );

    document.getElementById("slider_2").dataset.ged = armazenamento_gratuito;

    document.getElementById("slider_2").style.paddingLeft = 10+5*armazenamento_gratuito+"px";
    document.getElementById("slider_gratis").style.width = 11+5*armazenamento_gratuito+"px";
    document.getElementById("slider_2_em").style.left = 11+5*armazenamento_gratuito+"px";

    let valorAnualTotal = parseFloat(valor_por_processo * qtd_processos);
    //console.log( valorAnualTotal );

    let valorAnualDesconto = valorAnualTotal - valorAnualTotal*descontoAnual/100;

    if (this.state.cobranca === "mensal") {
      valorLawsuit = valorAnualTotal/12;
    } else if (this.state.cobranca === "anual") {
      valorLawsuit = valorAnualDesconto;
    }


    let valorStorage = this.state.valorStorage.replace('R$ ', '').replace('.', '').replace(',','.');
    let valorPublicacoes = this.state.valorPublicacoes.replace('R$ ', '').replace('.', '').replace(',','.');

    let total = valorLawsuit+parseFloat( valorStorage )+ parseFloat( valorPublicacoes ); 

    this.setState({
        qtd_processos,
        ged_gratis: armazenamento_gratuito,
        descontoAnual,
        valorLawsuit: parseFloat(valorLawsuit).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}),
        total: parseFloat(total).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}),
    });
     
  }

  atualizaStorage = () => {
    let qtd_storage = this.state.planStorages.map(x=>x.gb)[this.state.sliderStorage];
    let planStorages = this.state.planStorages;
    let valor = 0;

    //console.log(qtd_storage);

    let obj = this.state.planStorages.find(x => qtd_storage > 0 && qtd_storage <= x.gb);
    
    if( !obj && qtd_storage!=='0' && qtd_storage!==0 ){
      obj = planStorages.pop(); 
    }

    if(obj){
      valor = obj.valor;
    }

    if (this.state.cobranca === "mensal") {
      valor = valor;
    } else if (this.state.cobranca === "anual") {
      valor = valor*12 - (valor*12*15/100);
    }

    let qtd_storage_nice = "+"+qtd_storage+"GB";
    let valorLawsuit = this.state.valorLawsuit.replace('R$ ', '').replace('.', '').replace(',','.');
    let valorPublicacoes = this.state.valorPublicacoes.replace('R$ ', '').replace('.', '').replace(',','.');
    let total = parseFloat(valorLawsuit) +valor+ parseFloat(valorPublicacoes);

    this.setState({
        qtd_storage,
        qtd_storage_nice,
        valorStorage: parseFloat(valor).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}),
        total: parseFloat(total).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}),
    });

  }

  atualizaPublicacoes = () => {
    let qtd_publicacoes = this.state.sliderPublication;
    let planPublicacoes = this.state.planPublications;
    let valor = 0;

    //console.log(planPublicacoes);

    valor = qtd_publicacoes*planPublicacoes[0].valor;

    if (this.state.cobranca === "mensal") {
      valor = valor;
    } else if (this.state.cobranca === "anual") {
      valor = valor*12 - (valor*12*15/100);
    }
      
    let valorLawsuit = this.state.valorLawsuit.replace('R$ ', '').replace('.', '').replace(',','.');
    let valorStorage = this.state.valorStorage.replace('R$ ', '').replace('.', '').replace(',','.');
    let total = parseFloat(valorLawsuit) +valor+ parseFloat(valorStorage);

    this.setState({
        qtd_publicacoes,
        valorPublicacoes: parseFloat(valor).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}),
        total: parseFloat(total).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}),
    });

  }

  clickCobranca = (e) => {
      e.preventDefault();
     //console.log(e.target);

      if( e.target.dataset.btn === "mensal" ) {
          //console.log("mensal");
          e.target.className += " active";
          document.getElementById("btn-anual").classList.remove("active");

          this.setState({
              cobranca: "mensal"
          });
      }else{
        //console.log("anual");
        e.target.className += " active";
        document.getElementById("btn-mensal").classList.remove("active");

        this.setState({
            cobranca: "anual"
        });
      }

      setTimeout(() => {
        this.atualizaProcesso();
        this.atualizaStorage();
        this.atualizaPublicacoes();
      }, 200);

  }

  handleChange(e){

       this.setState(
           {
               [e.target.name]: e.target.value
           }
       )
       setTimeout(() => {
            this.atualizaProcesso();
            this.atualizaStorage();
            this.atualizaPublicacoes();
       }, 200);
   }

   setBandeira(e){
     if( this.state.cadastro_ModoPagamento === "debito" ) {
          let cur_val = this.state.card_number;
          cur_val = cur_val.replace(/\D/g, '');
          // Visa
          let visa_regex = new RegExp('^4[0-9]{0,}$'); //4
          if (cur_val.match(visa_regex)) {
            this.setState({
              card_company_code: "visa_electron"
            });
          } else{
            let mastercard_regex = new RegExp('^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)[0-9]{0,}$'); //2221-2720, 51-55
            let maestro_regex = new RegExp('^(5[06789]|6)[0-9]{0,}$'); //always growing in the range: 60-69, started with / not something else, but starting 5 must be encoded as mastercard anyway
            if (cur_val.match(mastercard_regex) || cur_val.match(maestro_regex) ) {
              this.setState({
                card_company_code: "maestro"
              });
            }
          }
     }
   }

   selectChange = (selected, actionMeta) => {
     let pops = [];
     pops[ actionMeta.name ] = selected;
     if ( typeof actionMeta.name !== undefined && actionMeta.name !== "" && actionMeta.name !== null ){

       if ( typeof selected !== undefined && selected !== "" && selected !== null ) {
         this.setState( pops );
       }

     }
   }

   onSwitchChange = (checked) => {
    if ( checked ){
      //document.getElementById("modo_pagamento").classList.remove("hide");
      this.setState({
        alterarPagamento: true,
      });

    }else{
      //document.getElementById("modo_pagamento").className += " hide";
      this.setState({
        alterarPagamento: false,
      });

    }
  }

    validateForm = () => {

      let errors = {};
      let formIsValid = true;
      let message = "";

      //console.log( this.state.qtd_processos );
      //console.log( this.state.qtd_ativos );

      if ( this.state.qtd_processos < this.state.qtd_ativos ) {
        formIsValid = false;
        message =  "Você não pode reduzir seu plano para "+this.state.qtd_processos+" processos, pois atualmente tem "+this.state.qtd_ativos+" processos sendo monitorados." ;
      }

      //console.log( this.state.qtd_storage+this.state.ged_free );
      //console.log( this.state.ged_utilized );

      if ( ( this.state.qtd_storage+this.state.ged_free ) < this.state.ged_utilized ) {
        formIsValid = false;
        message += "\nVocê não pode reduzir seu plano GED para "+this.state.qtd_storage+" GB, pois atualmente tem "+this.state.ged_utilized+" GB sendo usados." ;
      }

      if ( ( this.state.qtd_publicacoes ) < this.state.publications.length ) {
        formIsValid = false;
        message += "\nVocê não pode reduzir seu plano de Publicações para "+this.state.qtd_publicacoes+", pois atualmente tem "+this.state.publications.length+" nomes em uso." ;
      }

      if( this.state.alterarPagamento && ( this.state.card_cvv === "" || this.state.card_cvv === null || typeof this.state.card_cvv === "undefined" || this.state.card_cvv.length < 3 )  ){
        formIsValid = false;
        errors['card_cvv'] = "Obrigatório informar o código de 3 dígitos do verso do Cartão.";
      }

      if( this.state.alterarPagamento && (this.state.card_expiration.substr(0,2) > 12 || this.state.card_expiration.substr(0,2) < 1 )  ){
        formIsValid = false;
        errors['card_expiration'] = "A data de validade informada não existe.";
      }

      if( this.state.alterarPagamento && this.state.card_expiration.substr(3,2) < moment().format('YY')  ){
        formIsValid = false;
        errors['card_expiration'] = "O Cartão está com a validade vencida";
      }else if( this.state.alterarPagamento && this.state.card_expiration.substr(3,2) === moment().format('YY') && this.state.card_expiration.substr(0,2) < moment().format('MM') ){
        formIsValid = false;
        errors['card_expiration'] = "O Cartão está com a validade vencida";
      }

      if ( message !== "" ){        
        //alert( message );
        this.setState({
          showAlert: true,
          message
        });
      }

      this.setState({
        errors: errors
      });

      return formIsValid;

    }

    changePlan = () => {

              if ( this.validateForm() ) {

                this.setState({
                  loadingVisible: true,
                  loadingMessage: ["As alterações estão sendo salvas.", "Por gentileza, aguarde...", "Tempo estimado de 45 a 90 segundos"]
                });
          
                  this.OfficeService = new OfficeService();
                  let token = JSON.parse(localStorage.getItem('loggedUser')).office_token;
          
                  /*console.log( this.state.planLawsuits );
                 //console.log( this.state.planStorages );
                 //console.log( this.state.sliderLawsuit );
                 //console.log( this.state.sliderStorage );*/
          
                  let dados = {
                    plan_lawsuit_id: this.state.planLawsuits[ this.state.sliderLawsuit ].id,
                    plan_storage_id: this.state.planStorages[ this.state.sliderStorage ].id,
                    plan_publication_number: this.state.sliderPublication,
                    anual: ( this.state.cobranca === "anual" ) ? 1 : 0
                  };
          
                  if( this.state.alterarPagamento ){
                    dados.holder_name = this.state.holder_name;
                    dados.card_expiration = this.state.card_expiration;
                    dados.card_number = this.state.card_number;
                    dados.card_cvv = this.state.card_cvv;
                    dados.method = this.state.cadastro_ModoPagamento;

                    if( this.state.cadastro_ModoPagamento ===  "debito" ) {
                      dados.card_company_code = this.state.card_company_code;
                    }
          
                    //console.log( dados );
                  }

                  //console.log( dados );
          
                  this.OfficeService.changePlan( dados ).then(response =>{

                        if( this._isMounted ) {
          
                              if( response.success === true ){                                  

                                  localStorage.setItem('alert_message', response.message );
                                  localStorage.setItem('alert_type', 'alert-success');
                                  let time = new Date().getTime();
                                  localStorage.setItem('alert_time', time );
                                  setTimeout(() => {
                                    this.setState({
                                      updated: time,
                                    });
                                  }, 300);
                                  //alert("Comentário adicionado com sucesso");
                              }else{
                                //alert( response.message );
                                this.setState({
                                  showAlert: true,
                                  message: response.message
                                });
                              }
                    
                              this.setState({
                                loadingVisible: false,
                                holder_name: "",
                                card_expiration: "",
                                card_number: "",
                                card_cvv: ""
                              });

                              this.atualizaDados();

                        }
          
                  });

              }
    }

   update = (event, r = false) => {

        if ( ( this.state.qtd_processos < this.state.plan ) || ( this.state.qtd_storage < this.state.ged_gb ) || this.state.qtd_publicacoes < this.state.n_publicacoes ) {
          if ( r ){
            this.changePlan();
          }else{
            this.setState({
              showConfirm: true,
              message: "Ao confirmar, somente será possivel realizar novo Downgrade após 60 dias"
            });
          }
        }else{
                this.changePlan();
        }

   }

   publicationItem = ( {record, index}, type ) => {

      return (
        <div key={record.token} className={type}>
              <div className="form-group col-md-7">
                  <span><b>Nome: </b></span><span>{record.name}</span>
              </div>
              <div className="form-group col-md-5">
                    <span><b>OAB: </b></span><span>{record.oab}</span>
              </div>
        </div>
      );
  };

  render() {

      let free_container = null;

      if( this.state.free !== ""){
        free_container = <span className="red">{this.state.free}</span>
      }

      //<option value="debito">Cartão de débito</option>

      return <div className="config-office change-plan-screen sheet">
                <style dangerouslySetInnerHTML={ this.setStyle() } />
                <HeaderBar />
                <NavigationMenu />
                <FlashMessage time={ new Date().getTime() } />
                <Confirm show={this.state.showConfirm} text={this.state.message} />
                <Loading visible={this.state.loadingVisible} message1={this.state.loadingMessage[0]} message2={this.state.loadingMessage[1]} message3={this.state.loadingMessage[2]} cancel={true}   />
                <Alert show={this.state.showAlert} text={this.state.message} />
                <div className="content-wrapper">
                  <div className="content-wrapper-inner">
                      <section className="content-header">
                        <h1 className="page-header">Configurações</h1>
                      </section>
                      <div className="panel panel-primary">
                            <div className="panel-heading text-center">
                                  <h4>Alteração de Plano</h4>
                            </div>
                      </div>
                      <div className="box-body">
                        <div className="form-group col-md-12">
                              <h5>
                                    Plano Atual{this.state.free}
                                    <span className="pull-right red">{free_container} Data de expiração: {this.state.expiration.substr(0,10).split('-').reverse().join('/')}</span>
                              </h5>
                        </div>
                        <div className="form-group col-md-3">
                                <div className="service-title col-md-12">
                                      <p>Processos</p>
                                </div>
                                <div className="form-group col-md-12">
                                      <span><b>Plano Atual: </b></span><span>{this.state.plan} Processos</span>
                                </div>
                                <div className="form-group col-md-12">
                                      <span><b>Ativos/Cadastros: </b></span><span>{this.state.qtd_ativos} Processos</span>
                                </div>
                        </div>
                        <div className="form-group col-md-3">
                                <div className="service-title col-md-12">
                                      <p>GED</p>
                                </div>
                                <div className="form-group col-md-12 ">
                                      <span><b>Espaço de GED: </b></span><span>{this.state.ged_gb} GB + {this.state.ged_free} GB grátis</span>
                                </div>
                                <div className="form-group col-md-12 ">
                                      <span><b>Espaço utilizado do GED: </b></span><span>{this.state.ged_percent} %</span>
                                </div>
                        </div>
                        <div className="form-group col-md-6">
                                <div className="service-title col-md-12">
                                      <p>Publicações</p>
                                </div>
                                <div className="form-group col-md-12 ">
                                    <span><b>Nomes Contratados: </b></span><span>{this.state.n_publicacoes}</span>
                                </div>
                                { ( typeof this.state.publications !== "undefined") ? this.state.publications.map( (record, index) => this.publicationItem( {record, index}, 'pub-item' ) ) : null }

                        </div>
  <div className="resultado-periodo valor-total">Valor do Plano Atual: <b className="">{this.state.totalPlan}</b></div>
                        <div className="form-group col-md-12">
                              <h5>
                                    Escolher Novo Plano
                              </h5>
                        </div>
                        <div className="form-group col-md-12">
                                <div className="row">
                                    <div className="col-12 titulo">
                                        <p>Simule seu plano de acordo com as suas necessidades.</p>
                                        <div className="btns-toogle">
                                            <a id="btn-mensal" href="/" data-btn="mensal" className="btn-mensal active" onClick={this.clickCobranca }>Mensal</a>
                                            <a id="btn-anual" href="/" data-btn="anual" className="btn-anual" onClick={this.clickCobranca }>Anual (<span id="desconto_anual" className="desconto_anual">{this.state.descontoAnual}</span>% off)</a>
                                            <input type="hidden" id="cobranca" name="cobranca" value={this.state.cobranca} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xl-10 offset-xl-1 slider">
                                        <i><svg xmlns="http://www.w3.org/2000/svg" width="77.4" height="60.47" viewBox="0 0 77.4 60.47" fill="#57b317"><path className="cls-1" d="M1229.96,8296.72a7.265,7.265,0,0,1-14.53,0v-24.8h2.35a1.526,1.526,0,0,0,0-3.05h-2.35v-9.33a1.573,1.573,0,0,0-.45-1.08L1203.51,8247a1.545,1.545,0,0,0-1.08-.44h-24.67a4.575,4.575,0,0,0-4.57,4.57v48.37a7.535,7.535,0,0,0,7.54,7.52h41.96a10.322,10.322,0,0,0,10.32-10.3v-2.32h13.01a4.575,4.575,0,0,0,4.57-4.57v-10.65a10.328,10.328,0,0,0-10.31-10.31h-10.21a1.526,1.526,0,0,0,0,3.05h2.89a10.275,10.275,0,0,0-3,7.26v17.54h0Zm-26.01-44.96,6.27,6.26h-6.27v-6.26Zm8.43,44.96a10.293,10.293,0,0,0,3,7.26h-34.65a4.488,4.488,0,0,1-4.49-4.48v-48.37a1.528,1.528,0,0,1,1.52-1.53h23.15v9.94a1.519,1.519,0,0,0,1.52,1.52h9.95v35.66h0Zm35.16-6.89a1.519,1.519,0,0,1-1.52,1.52h-13.01v-4.02h6.42a1.521,1.521,0,0,0,0-3.04h-6.42v-3.06h6.42a1.526,1.526,0,0,0,0-3.05h-6.35a7.265,7.265,0,0,1,14.46,1v10.65Zm-66.86-28.77H1192a1.521,1.521,0,0,0,0-3.04h-11.32A1.521,1.521,0,0,0,1180.68,8261.06Zm0,6.11h27.12a1.526,1.526,0,0,0,0-3.05h-27.12A1.526,1.526,0,0,0,1180.68,8267.17Zm0,6.1h9.55a1.526,1.526,0,0,0,0-3.05h-9.55A1.526,1.526,0,0,0,1180.68,8273.27Zm0,6.1h27.12a1.521,1.521,0,0,0,0-3.04h-27.12A1.521,1.521,0,0,0,1180.68,8279.37Zm27.49,3.06h-27.49a1.522,1.522,0,0,0-1.53,1.52v12.4a1.53,1.53,0,0,0,1.53,1.53h27.49a1.528,1.528,0,0,0,1.52-1.53v-12.4A1.519,1.519,0,0,0,1208.17,8282.43Zm-1.53,12.4H1182.2v-9.35h24.44v9.35Zm-10.57-24.57a1.521,1.521,0,1,0,1.68.84A1.535,1.535,0,0,0,1196.07,8270.26Zm26.5,0.72a1.522,1.522,0,1,0,.82-1.99A1.531,1.531,0,0,0,1222.57,8270.98Z" transform="translate(-1173.19 -8246.56)"></path></svg></i>
                                        <div className="content">
                                            <div className="servico-titulo">
                                                <h4 className="text-lg-nowrap">Quantidade de processos <span className="">monitorados</span>
                                                      <MyPopover icon="white" text="Selecione a quantidade de processos ativos que deseja monitorar diariamente." />
                                                </h4>
                                            </div>
                                            <em>(quanto mais processos, mais barato o valor por processo!)</em>
                                            <input id="sliderLawsuit" name="sliderLawsuit" type="range" step="1" value={this.state.sliderLawsuit} max={this.state.maxLawsuits} min="0" onChange={this.handleChange} />
                                        </div>
                                        <div className="valores">
                                            <input id="qtd_processos" name="qtd_processos" className="qtd" type="text" value={this.state.qtd_processos} readOnly={true} />
                                            <input id="preco1" className="preco" type="text" placeholder="R$ XX,XX" value={this.state.valorLawsuit} readOnly={true} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xl-10 offset-xl-1 slider">
                                        <i><svg xmlns="http://www.w3.org/2000/svg" width="91.88" height="80.78" viewBox="0 0 91.88 80.78" fill="#57b317"><path d="M1211.06,8382.05a14.2,14.2,0,0,0-10.09,4.17,1.584,1.584,0,0,0,2.24,2.24,0.01,0.01,0,0,1,.01-0.01,11.087,11.087,0,0,1,15.68,0h0a1.59,1.59,0,0,0,2.24.01l0.01-.01a1.569,1.569,0,0,0,0-2.23A14.182,14.182,0,0,0,1211.06,8382.05Zm14.56-.31a20.593,20.593,0,0,0-29.12,0,1.578,1.578,0,0,0-.01,2.23l0.01,0.01a1.581,1.581,0,0,0,2.24,0,17.431,17.431,0,0,1,24.64,0h0.01a1.584,1.584,0,0,0,2.24-2.24h-0.01Zm-14.56,6.64a7.953,7.953,0,0,0-5.59,2.32,1.581,1.581,0,0,0,2.23,2.23,4.762,4.762,0,0,1,6.72,0,1.585,1.585,0,0,0,2.41-2.06,1.448,1.448,0,0,0-.18-0.17,7.953,7.953,0,0,0-5.59-2.32h0Zm34.17,22.06h-0.46a18.543,18.543,0,0,0-33.71-4.66,18.516,18.516,0,0,0-32.71,1.94h-0.1a13.125,13.125,0,1,0,7.69,23.74,18.349,18.349,0,0,0,7.7,2.39v10.28a6.346,6.346,0,0,0-4.54,4.53h-11.31a1.58,1.58,0,1,0,0,3.16h11.31a6.334,6.334,0,0,0,12.23,0h19.46a6.334,6.334,0,0,0,12.23,0h11.31a1.58,1.58,0,1,0,0-3.16h-11.31a6.333,6.333,0,0,0-4.53-4.53v-10.26a18.071,18.071,0,0,0,8.74-3.07,11.753,11.753,0,1,0,7.92-20.36h0.08Zm-58.53,17.76a1.594,1.594,0,0,0-1.92.13,9.949,9.949,0,1,1-6.53-17.42h0.97a1.573,1.573,0,0,0,1.58-1.01,15.391,15.391,0,0,1,28.76,0,14.533,14.533,0,0,1,.71,2.5,1.583,1.583,0,0,0,1.82,1.25,9.583,9.583,0,0,1,1.41-.12,8.6,8.6,0,1,1-6.6,14.1,1.64,1.64,0,0,0-1.21-.57,1.6,1.6,0,0,0-.98.34,15.382,15.382,0,0,1-18.06.74Zm8.52,25.21a3.17,3.17,0,1,1,3.17-3.17A3.171,3.171,0,0,1,1195.22,8453.41Zm25.57-4.75h-19.46a6.317,6.317,0,0,0-4.53-4.53v-10.24a18.408,18.408,0,0,0,8.75-3.17,11.685,11.685,0,0,0,13.89,1.58,18.411,18.411,0,0,0,5.88,1.51v10.27A6.332,6.332,0,0,0,1220.79,8448.66Zm9.28,1.58a3.17,3.17,0,1,1-3.17-3.17A3.171,3.171,0,0,1,1230.07,8450.24Zm15.16-19.46a8.519,8.519,0,0,1-6.59-3.16,1.582,1.582,0,0,0-2.23-.16,15.259,15.259,0,0,1-9.51,3.32,15.7,15.7,0,0,1-4.62-.72,11.755,11.755,0,0,0-8.73-19.64h-0.46c-0.1-.34-0.21-0.69-0.33-1.04a15.382,15.382,0,0,1,29.24,3.07,1.583,1.583,0,0,0,1.82,1.25,8.374,8.374,0,0,1,1.41-.11,8.6,8.6,0,1,1,.74,17.18c-0.25.01-.49,0.01-0.74,0v0.01Z" transform="translate(-1165.09 -8375.72)"></path></svg></i>
                                        <div className="content">
                                            <div className="servico-titulo">
                                                <h4 className="text-lg-nowrap">Espaço adicional para Documentos em Nuvem <span className="">(GED)</span>
                                                      <MyPopover icon="white" text="Selecione a quantidade de espaço adicional que deseja ter para gerenciamento eletrônico de documentos." />
                                                </h4>
                                            </div>
                                            <div id="slider_2" className="slider_2" data-ged="1" >
                                                <span id="slider_gratis" className="slider_gratis" ><em id="slider_2_em"><strong><span className="ged_gratis">{this.state.ged_gratis}</span> GB</strong> (grátis)*</em></span>
                                                <input id="sliderStorage" name="sliderStorage" type="range" step="1" min="0" value={this.state.sliderStorage} max="18" onChange={this.handleChange} />
                                            </div>
                                        </div>
                                        <div className="valores">
                                            <input id="valor2_txt" name="espaco_txt" className="qtd" type="text" value={this.state.qtd_storage_nice} readOnly={true} />
                                            <input id="valor2" name="espaco" type="hidden" value="0" readOnly={true} />
                                            <input id="preco2" className="preco" type="text" placeholder="R$ XX,XX" value={this.state.valorStorage}  readOnly={true} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xl-10 offset-xl-1 slider">
                                        <i><svg xmlns="http://www.w3.org/2000/svg" width="69.72" height="72.63" viewBox="0 0 69.72 72.63" fill="#57b317"><path d="M1230.3,8540.59a1.626,1.626,0,0,1-1.62-1.62V8527.9a1.62,1.62,0,0,1,3.24,0v11.07A1.626,1.626,0,0,1,1230.3,8540.59Zm-0.01-19.51a1.62,1.62,0,1,1-1.62,1.62A1.62,1.62,0,0,1,1230.29,8521.08Zm16.99,8.94a17.016,17.016,0,0,0-16.99-17,16.844,16.844,0,0,0-10.31,3.51h-36.54a5.892,5.892,0,0,0-5.88,5.89v48.63a5.9,5.9,0,0,0,5.88,5.89h5.14v2.81a5.892,5.892,0,0,0,5.88,5.89h38.05a5.892,5.892,0,0,0,5.88-5.89v-12.21a1.615,1.615,0,1,0-3.23,0v12.21a2.657,2.657,0,0,1-2.65,2.66h-38.05a2.657,2.657,0,0,1-2.65-2.66v-2.81h29.68a5.9,5.9,0,0,0,5.89-5.89v-24.28a16.487,16.487,0,0,0,2.91.25,16.677,16.677,0,0,0,4.87-.71v6.6a1.615,1.615,0,1,0,3.23,0v-7.95a17.015,17.015,0,0,0,8.89-14.94h0Zm-23.14,41.03a2.648,2.648,0,0,1-2.65,2.65h-38.05a2.655,2.655,0,0,1-2.65-2.65v-48.63a2.657,2.657,0,0,1,2.65-2.66h33.32a16.947,16.947,0,0,0-3.44,9.55h-23.31a1.609,1.609,0,0,0-1.61,1.61v6.84a1.618,1.618,0,0,0,1.61,1.62h24.91a1.65,1.65,0,0,0,.98-0.33,17.08,17.08,0,0,0,8.24,6.82v25.18Zm-10.83-38.51v3.6h-21.68v-3.6h21.68Zm16.98,11.25a13.765,13.765,0,1,1,13.75-13.77A13.779,13.779,0,0,1,1230.29,8543.79Zm6.49,18.02a1.621,1.621,0,0,1-1.03-2.87,1.618,1.618,0,0,1,2.6,1.62A1.623,1.623,0,0,1,1236.78,8561.81Zm-21.86-13.57h-24.91a1.62,1.62,0,0,1,0-3.24h24.91A1.62,1.62,0,0,1,1214.92,8548.24Zm0,7.68h-24.91a1.62,1.62,0,0,1,0-3.24h24.91A1.62,1.62,0,1,1,1214.92,8555.92Zm0,7.67h-24.91a1.62,1.62,0,0,1,0-3.24h24.91A1.62,1.62,0,1,1,1214.92,8563.59Z" transform="translate(-1177.56 -8513.03)"></path></svg></i>
                                        <div className="content">
                                            <div className="servico-titulo">
                                                <h4 className="text-lg-nowrap">Publicações por nome <span className="">(DOU)</span>
                                                <MyPopover icon="white" text="Selecione a quantidade de nomes (OABs) que terão suas publicações atualizadas." />
                                                </h4>
                                            </div>
                                            <input id="sliderPublication" name="sliderPublication" type="range" step="1" value={this.state.sliderPublication} max="20" min="0" onChange={this.handleChange} />
                                        </div>
                                        <div className="valores">
                                            <input id="valor3" name="publicacao" className="qtd" type="text" value={this.state.qtd_publicacoes}  readOnly={true} />
                                            <input id="preco3" className="preco" type="text" placeholder="R$ XX,XX" value={this.state.valorPublicacoes} readOnly={true} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xl-10 offset-xl-1 slider slider-total">
                                        <p>Total do Novo plano (cobrado somente na próxima fatura)</p>
                                        <input id="total" className="preco" type="text" placeholder="R$ XX,XX" value={this.state.total} readOnly={true} />
                                    </div>
                                </div>
                                <div className="row alterarPagamento">
                                    <h5 className="">
                                          Cadastrar ou alterar cartões

                                          <MyPopover icon="white" text="Caso já tenha um cartão cadastrado, não há a necessidade de recadastro. Somente preencha os dados se for uma nova contratação ou uma troca de cartão!" />
                                          <Switch checked={this.state.alterarPagamento} onChange={ this.onSwitchChange }  />
                                    </h5>
                                </div>
                                <div id="modo_pagamento" className="modo_pagamento cartao_credito col-md-7">
                                    <div className="form-group col-md-6">
                                        <label htmlFor="cadastro_ModoPagamento">
                                          * Modo de pagamento
                                        <MyPopover icon="white" text="Na modalidade Cartão de Débito, o titular receberá um e-mail para autorizar o débito em conta corrente. Isso ocorrerá todos os meses, mas lembramos que se não for autorizado, o sistema será interrompido por falta de pagamento." />
                                        </label>
                                        <select name="cadastro_ModoPagamento" disabled={!this.state.alterarPagamento} value={this.state.cadastro_ModoPagamento} onChange={this.handleChange} className="form-control valid" id="cadastro_ModoPagamento" aria-required="true" aria-invalid="false">
                                            <option value="credito">Cartão de crédito</option>
                                        </select>
                                    </div>
                                    <div className="form-group col-md-12">
                                        <label htmlFor="holder_name">* Nome <strong>do titular</strong> <span>(como gravado no cartão)</span></label>
                                        <input type="text" className="form-control" autoComplete="new-password" name="holder_name"  value={this.state.holder_name} disabled={!this.state.alterarPagamento} id="holder_name" onChange={this.handleChange}  placeholder="Digite o nome como gravado no cartão" />
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label htmlFor="card_number">* Número do cartão</label>
                                        <InputMask  type="text" className="form-control" name="card_number"  value={this.state.card_number} autoComplete="new-password" disabled={!this.state.alterarPagamento}  id="card_number" onChange={this.handleChange} onKeyUp={this.setBandeira} placeholder="Digite o número do cartão" mask="9999.9999.9999.9999" maskChar="_"  />
                                    </div>
                                    <div className="form-group col-6 col-md-3">
                                        <label htmlFor="card_expiration">* Validade</label>
                                        <InputMask  type="text" className="form-control" name="card_expiration" value={this.state.card_expiration} autoComplete="new-password" disabled={!this.state.alterarPagamento}  id="card_expiration" onChange={this.handleChange} placeholder="MM/AA" mask="99/99" maskChar="_" />
                                        <div className="errorMsg">{this.state.errors.card_expiration}</div>
                                    </div>
                                    <div className="form-group col-6 col-md-3">
                                        <label htmlFor="card_cvv">* CVV</label>
                                        <input type="text" className="form-control" name="card_cvv" value={this.state.card_cvv} autoComplete="new-password" disabled={!this.state.alterarPagamento}  id="card_cvv" onChange={this.handleChange} placeholder="000" maxLength="3" />
                                        <div className="errorMsg">{this.state.errors.card_cvv}</div>
                                    </div>
                                    <div className={  (this.state.cadastro_ModoPagamento === "debito") ? "form-group col-6 col-md-6" : "hide"} >
                                            <label htmlFor="card_company_code">* Bandeira</label>
                                            <select name="card_company_code" disabled={!this.state.alterarPagamento} value={this.state.card_company_code} onChange={this.handleChange} className="form-control" id="card_company_code" required="required" aria-required="true">
                                                    <option value="" disabled="disabled">Selecione uma bandeira</option>
                                                    <option value="maestro">Maestro</option>
                                                    <option value="visa_electron">Visa Electron</option>
                                            </select>
                                    </div>
                                </div>
                                <div className="form-content form-assinar">
                                    <button className="btn" onClick={this.update}>Alterar Plano</button>
                                </div>
                        </div>

                      </div>
                  </div>
                </div>
             </div>
  }

}
